import { Component } from '@angular/core';
import { ButtonIconComponent } from '../../../../../../../shared/components/button-icon/button-icon.component';
import { InputKeyValues } from '../../../../../../../shared/components/input-key-values/input-key-values';
import { TranslateSafePipe } from '../../../../../../../shared/pipes/translation.pipe';
import { AlarmRuleActionDeviceUpdateConfig } from '../../../../../../../types/dtos/alarm-rule-action.dto';
import { InputKeyValuesInterface } from '../../../../../../../types/interfaces/input.interface';
import { BaseAction } from '../base-action';
import { BaseRuleAction } from '../base-rule-action';
import { DeviceUpdateRuleAction } from './device-update.rule-action';

@Component({
  selector: 'app-device-update-action',
  imports: [
    InputKeyValues,
    ButtonIconComponent,
    TranslateSafePipe,

  ],
  templateUrl: './device-update-action.html',
  styleUrls: [
    './device-update-action.css',
    '../base-rule-action.css',
  ],
})
export class DeviceUpdateAction extends BaseAction {
  override ruleAction: BaseRuleAction = new DeviceUpdateRuleAction();

  public get getDefaultValueString(): string {
    let config = this.getConfig() as unknown as AlarmRuleActionDeviceUpdateConfig;
    let strings: string[] = [];

    Object.keys(config.update)
      .some(key => {
        let v: string = (config.update as Record<string, string>)[key] as string;

        strings.push(key + ': ' + (v ?? '-'));
      });

    return strings.join('<br>');
  }

  public getDeviceUpdateInput(): InputKeyValuesInterface {
    return {
      formGroup: this.formGroup,
      label: '',
      required: true,
      id: 'deviceUpdate',
      predefinedKeys: ['status'],
    };
  }
}
